<template>
  <svg-icon type="mdi" :path="iconMenu"></svg-icon>
</template>

<script setup>
import { ref } from 'vue'
import SvgIcon from '@jamescoyle/vue-icon'
import { mdiMenu } from '@mdi/js'
const iconMenu = ref(mdiMenu)
</script>
